import type { FaireProductEntity } from "../../entity_types/product";

export const p_hp2qzt4mjr: FaireProductEntity = {
  token: "p_hp2qzt4mjr",
  type: "product",
  name: "DUBAI-STYLE CHOCOLATE BUNNY IN FLOW WRAP",
  brandName: "Gotta Get It Gifts",
  imageUrl:
    "https://cdn.faire.com/fastly/a3f58ba148b9631689ed57012fe3313f5ae6308f12493f4a5329b10af24331f3.jpeg",
  priceDollars: 0,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/6dbf5a3ed490001f36a3511eba648c4068cb4791891080ae56bd0963ed3966fb.jpeg",
  weight: 1,
  dimensions: {
    width: 6,
    height: 6,
    depth: 4,
  },
  inStock: true,
};
